import { render, staticRenderFns } from "./AccordionAlgoServer.vue?vue&type=template&id=1ea19cfc"
import script from "./AccordionAlgoServer.vue?vue&type=script&lang=js"
export * from "./AccordionAlgoServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports